import React from 'react';
import { Group, Container } from './styles';
import ProjectCard from '../../../../component/projectCard';
import { FavoriteProps } from '../../../../interfaces/ProjectInterface';

const Favorite: React.FC<FavoriteProps> = (props) => {
  const { onClickFavorite, onClickProjectList, favoriteProjects } = props;

  return (
    <>
      <Group>
        <Container>
          {favoriteProjects?.map((item) => {
            return (
              <ProjectCard
                key={item.id}
                projectId={item?.id}
                onClickProjectList={() => onClickProjectList(item)}
                onClickFavorite={(e) => {
                  onClickFavorite(e, item, false);
                }}
                projectName={item?.name}
                projectCustomer={item?.customer?.companyName}
                projectIcon={item?.icon}
                progressData={item?.progressData}
                projectUsers={item?.users}
              />
            );
          })}
        </Container>
      </Group>
    </>
  );
};
export default Favorite;
